var Ractive = require('ractive');
var component = module;

  component.exports = {
    onrender: function (options) {
      var self = this;

      self.set('loading', false);
      self.on('doRefresh', function (e) {
        if(Global&&Global.Session&&Global.Session.Status){
          self.set('d.Tab', 'profil');

          var fRequest = {
                Name: "Sql",
                Action: "Query",
                Query: "ERP-Profile-Web",
                Payload: {
                  username: Global.Session.UserName,
                  useruid: Global.Session.UserUID,
                  infokey: Global.Session.InfoKey
                },
                Behavior: { Rows: "UserRow", loading: "loading", singleRow: true }
              };
          self.cmd.Data(self, fRequest, function(oData){
            if(oData.Status){
              let fLoginElm = document.getElementsByClassName("nte-login");
              if(fLoginElm&&0<fLoginElm.length){
                fLoginElm[0].textContent = oData.Data.syscaption;
              }    
              if(oData.Data.infolast){
                self.set('InfoSelected', oData.Data.infolast);
              }else{
                self.set('InfoSelected', oData.Data.infodefault);
              }
              self.set('InfoSelected', '');
            }else{
              self.set('InfoSelected', '');
            }
          });          
        }else{
          self.set('d.Tab', 'notfound');
        }
      });
      self.on('doGo', function (iInfoUid) {       
        const fLoading = self.get('loading');
        
        if(fLoading){
          return;
        } 

        self.set('loading', true);

        let fInfoUid = (iInfoUid) ? iInfoUid : self.get('InfoSelected');

        self.set('InfoSelected', fInfoUid);

        if(fInfoUid){
          var fLogin = {
            InfoKey: iInfoUid,
            ProjectKey: ConfigClient.ProjectKey,
            UserName: self.get('UserRow.email'),
            UserPass: Global.Session.UID,
          };

          console.log('doGo', fLogin);

          self.cmd.Login(self, fLogin, function (oService, oData) {
            if(oData.Status){
              setTimeout(function(){ 
                self.set('loading', false);
                if(ConfigClient&&ConfigClient.DisplayURL){
                  window.location.href = ConfigClient.DisplayURL;
                }else{                
                  window.location.reload();
                }
              }, 800);
            }else{
              self.set('loading', false);
              self.set('MessageError', oData.Error);
            }
          });
        }
      });
      self.on('doLogout', function () {
        self.cmd.Logout(self, function (oData) {
          if(oData.Status){
            setTimeout(function(){ 
							window.location.href = "#";
							window.location.reload();
            }, 800);
          }
        });
      });
      self.fire('doRefresh');
    },
    data: function () {
      return {
        loading: false,
        InfoSelected: "",
        UserRow: [],
        MessageError: "",
        d: Client.createDisplay(),
        Lng: SiteLng.Page.Access,
        infoList: function(iValue){
          const myJson = Format.formatXml2Json(iValue);

          return myJson;
        }
      }
    }
  }

component.exports.template = {v:4,t:[{t:4,f:[{p:[2,1,28],t:7,e:"h3",m:[{n:"class",f:"font-size-24",t:13}],f:[{t:3,r:"UserRow.syscaption",p:[2,26,53]}]}," ",{p:[3,1,84],t:7,e:"small",m:[{n:"class",f:"text-muted",t:13}],f:["# ",{t:3,r:"UserRow.email",p:[3,34,117]}]}," ",{t:4,f:[{p:[5,1,169],t:7,e:"div",m:[{n:"class",f:"alert alert-warning mt-2",t:13},{n:"role",f:"alert",t:13}],f:[{p:[5,52,220],t:7,e:"i",m:[{n:"class",f:"fa fa-exclamation-circle",t:13},{n:"aria-hidden",f:"true",t:13}]},"  ",{t:3,r:"MessageError",p:[5,123,291]}]}],n:50,r:"MessageError",p:[4,1,146]},{t:4,n:51,f:[{p:[7,1,327],t:7,e:"p",f:[{t:3,r:"UserRow.sysdescription",p:[7,4,330]}," "]}],l:1},{p:[9,1,379],t:7,e:"small",m:[{n:"class",f:"text-muted",t:13}],f:[" FIRME"]}," ",{p:[10,1,426],t:7,e:"div",m:[{n:"class",f:"list-group",t:13}],f:[{t:4,f:[{p:[12,3,494],t:7,e:"a",m:[{n:"href",f:"javascript:;",t:13},{n:"click",f:{x:{r:["@this","."],s:"[_0.fire(\"doGo\",_1[0])]"}},t:70},{n:"class",f:["list-group-item list-group-item-action ",{t:4,f:["active"],n:50,x:{r:[".","InfoSelected"],s:"_0[0]==_1"},p:[12,108,599]}],t:13},{n:"aria-current",f:"true",t:13}],f:[{p:[13,5,668],t:7,e:"div",m:[{n:"class",f:"d-sm-flex w-100 justify-content-between",t:13}],f:[{t:4,f:[{p:[15,7,765],t:7,e:"h4",m:[{n:"class",f:"list-group-item-heading text-fixed-white",t:13}],f:[{t:3,rx:{r:".",m:[{r:[],s:"1"}]},p:[15,60,818]}]}],n:50,x:{r:[".","InfoSelected"],s:"_0[0]==_1"},p:[14,7,730]},{t:4,n:51,f:[{p:[17,7,858],t:7,e:"h4",m:[{n:"class",f:"list-group-item-heading",t:13}],f:[{t:3,rx:{r:".",m:[{r:[],s:"1"}]},p:[17,43,894]}]}],l:1}," ",{p:[19,7,933],t:7,e:"small",f:[" "]}]}," ",{p:[21,5,974],t:7,e:"p",m:[{n:"class",f:"mb-1",t:13}],f:[{t:3,rx:{r:".",m:[{r:[],s:"2"}]},p:[21,21,990]}]}]}],i:"i",x:{r:["infoList","UserRow.infodata"],s:"_0(_1)[0]"},p:[11,3,454]}]}," ",{p:[25,1,1031],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{p:[26,3,1052],t:7,e:"div",m:[{n:"class",f:"mt-2",t:13}],f:[{t:4,f:[{p:[28,5,1098],t:7,e:"button",m:[{n:"class",f:"btn btn-primary w-100 ex-action",t:13},{n:"disabled",f:0,t:13}],f:[{p:[28,62,1155],t:7,e:"div",m:[{n:"class",f:"spinner-border spinner-border-sm",t:13},{n:"role",f:"status",t:13}],f:[{p:[28,123,1216],t:7,e:"span",m:[{n:"class",f:"visually-hidden",t:13}],f:["Wait..."]}]}]}],n:50,r:"loading",p:[27,5,1076]},{t:4,n:51,f:[{t:4,f:[{p:[31,7,1328],t:7,e:"button",m:[{n:"class",f:"btn btn-primary w-100 ex-action",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doGo\")]"}},t:70}],f:["NASTAVI"]}],n:50,r:"InfoSelected",p:[30,7,1299]},{t:4,n:51,f:[{p:[33,7,1448],t:7,e:"button",m:[{n:"class",f:"btn btn-outline-primary w-100 ex-action",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doGo\")]"}},t:70},{n:"disabled",f:0,t:13}],f:["IZABERI FIRMU"]}],l:1}],l:1}]}]}," ",{p:[38,1,1615],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{p:[39,3,1636],t:7,e:"div",m:[{n:"class",f:"mt-3",t:13}],f:[{p:[40,5,1660],t:7,e:"a",m:[{n:"class",f:"link-primary link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline ex-action",t:13},{n:"href",f:"/registracija",t:13}],f:["Želim da registrujem novu firmu"]}," ",{p:[41,5,1841],t:7,e:"br"}," ",{p:[42,5,1851],t:7,e:"a",m:[{n:"class",f:"link-primary link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline ex-action",t:13},{n:"href",f:"javascript:void()",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doLogout\")]"}},t:70}],f:["Logout iz programa"]}]}]}],n:50,x:{r:["d"],s:"_0.isTab(\"profil\")"},p:[1,1,0]},{t:4,f:[{p:[47,1,2110],t:7,e:"h1",f:["NEMA KORISNIKA"]}],n:50,x:{r:["d"],s:"_0.isTab(\"notfound\")"},p:[46,1,2080]}],e:{"1":function (){return(1);},"2":function (){return(2);},"[_0.fire(\"doGo\",_1[0])]":function (_0,_1){return([_0.fire("doGo",_1[0])]);},"_0[0]==_1":function (_0,_1){return(_0[0]==_1);},"_0(_1)[0]":function (_0,_1){return(_0(_1)[0]);},"[_0.fire(\"doGo\")]":function (_0){return([_0.fire("doGo")]);},"[_0.fire(\"doLogout\")]":function (_0){return([_0.fire("doLogout")]);},"_0.isTab(\"profil\")":function (_0){return(_0.isTab("profil"));},"_0.isTab(\"notfound\")":function (_0){return(_0.isTab("notfound"));}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Element/InfoSelect.html
// module id = 38
// module chunks = 0